import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { GlobalApiService } from '@core/http/global-api.service';
import { Logout } from '@core/models/logout';
import { env } from 'process';
import { Auditlog, FontData } from '@core/models/auditlog';
import { AddNursingLocation } from 'app/er-medications/manage-nursing-locations-component/manage-nursing-locations-component.component';
import { RoleName } from 'app/physician/pojo/role-name.model';
import { CcdaCodeList } from 'app/physician/pojo/ccda-code-list.model';

const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class StaffserviceService {

  constructor(private apiService:GlobalApiService) { }
  
  // public getstaffusersdata(): Observable<HttpResponse<any>> {
  //   return this.http.get(
  //        environment.baseURL + "/" + environment.staff_users_url,
  //        { observe: 'response', headers: httpHeaders});
  // }
  getstaffusersdata(depId?,userId?,roleId?,LocationId?,physicianId?,searchType?, staffName?){
    // return this.apiService.getData(environment.staff + '?depId=' + depId + '&userId=' + userId + '&roleId=' + roleId + '&LocationId=' + LocationId + '&physicianId=' + physicianId + '&searchType=' + searchType + '&staffName=' + staffName);
    return this.apiService.getData(environment.staff);
  }
  getlocation(){
    return this.apiService.getData(environment.Stafflocation);
  }
  // getAllNurse(userId,locationId,filterIndex, searchValue){
  //   return this.apiService.getData(environment.NurseSearch+'?userId='+userId+'&locationId='+locationId+'&searchType='+filterIndex+'&nurName='+searchValue);
  // }
  getStaffSearch(depId,userId,roleId,LocationId,physicianId, searchType,staffName){
    // console.log("in staff service:::"+staffName);
    return this.apiService.getData(environment.StaffSearch + '?depId=' + depId + '&userId=' + userId + '&roleId=' + roleId + '&LocationId=' + LocationId + '&physicianId=' + physicianId + '&searchType=' + searchType + '&staffName=' + staffName);
  }
  saveNewStaffInfo(data):Observable<HttpResponse<any>>{
    return this.apiService.postData(environment.AddNewStaff, data);
  }
  saveNewStaff(data):Observable<HttpResponse<any>>{
    
    return this.apiService.postData(environment.InsertNewStaff, data);
  }
  // UpdateStaffdata(data):Observable<HttpResponse<any>>{
  //  return this.apiService.updateData(environment.InsertNewStaff, data);
  // }
  saveOtherInfoDetails(data):Observable<HttpResponse<any>>{
   return this.apiService.postData(environment.SaveOtherInfoDetails, data);
  }
  saveSchedulingDetails(data):Observable<HttpResponse<any>>{
    
    return this.apiService.postData(environment.SaveScheduling, data);
  }
  saveLocations(data):Observable<HttpResponse<any>>{
    return this.apiService.postData(environment.SaveLocation, data);
  }
  saveDepartments(data):Observable<HttpResponse<any>>{
   return this.apiService.postData(environment.SaveDepartment, data);
  }
  savePhysicians(data):Observable<HttpResponse<any>>{
    return this.apiService.postData(environment.SavePhysician, data);
  }
  saveServiceLevel(data):Observable<HttpResponse<any>>{
   return this.apiService.postData(environment.SaveServiceLevel, data);
    
  }
      // departments
    getDepartments():Observable<HttpResponse<any>>{
      return  this.apiService.getData(environment.cmrcDepartments)
    }
    //jobTitle
    getJobTitles():Observable<HttpResponse<any>>{
      return this.apiService.getData(environment.jobTitle)
    }

  getstaffRole(){
    return this.apiService.getData(environment.Role);
  }
  // getsevarity(){
  //   return this.apiService.getData(environment.sevarity);
  // }
  getStaffInfoById(StaffId):Observable<HttpResponse<any>>{
    return this.apiService.getData(environment.NewStaffInfo+'?StaffId='+StaffId);
  }
  getAllDepartment(){
    return this.apiService.getData(environment.allDepartment);
  }
  getdepartmentByStaffId(StaffId){
    return this.apiService.getData(environment.Department +"?StaffId=" + StaffId);
  }
  getLocationByStaffId(staffId){
    return this.apiService.getData(environment.MapLocation +"?staffId=" + staffId);
  }
  getLocationByStatus(staffId){
    return this.apiService.getData(environment.MapLocation +"?staffId=" + staffId);
  }
  getMapPhysician(staffId){
    return this.apiService.getData(environment.MapPhysician +"?staffId=" + staffId);
  }
  getAllPhysicianInfo(nurseId){
    return this.apiService.getData(environment.AllPhysicianInfo+"?staffId=" + nurseId );  
  }
  getServiceLevel(){
    return this.apiService.getData(environment.ServiceLevel );  
  }
  getAdjustSeverities():Observable<HttpResponse<any>>{
    return this.apiService.getData(environment.Severity);
  }
  checkUserId(userId):Observable<HttpResponse<any>>{
    return this.apiService.getData(environment.CheckUserId+'?userId='+userId);
  }
  deleteStaffLocations(StaffId, locationId):Observable<HttpResponse<any>>{
    return this.apiService.deleteData(environment.DeleteLocation+'?StaffId='+StaffId+'&LocationId='+locationId);
  }
  deleteStaffDepartments(StaffId, DepartmentId):Observable<HttpResponse<any>>{
    return this.apiService.deleteData(environment.DeleteDepartment+'?StaffId='+StaffId+'&DepartmentId='+DepartmentId);
  }
  deleteStaffPhysician(StaffId, physicianId):Observable<HttpResponse<any>>{
    return this.apiService.deleteData(environment.DeletePhysician+'?StaffId='+StaffId+'&physicianId='+physicianId);
  }
  saveResetPassword(data){
    return this.apiService.postData(environment.ResetPassword,data);
  }
  saveResetPasswordWithToken(data){
    return this.apiService.postData(environment.ResetPasswordwithtoken,data);
  }
  activateOrIntactivateStaffPhysician(LocationId, UserIntId,status):Observable<HttpResponse<any>>{
    return this.apiService.updateData(environment.ActivateInactivateUser+'?LocationId='+LocationId+'&UserIntId='+UserIntId+"&Status="+status,'');
  }
  saveStaffImage(body){
    return this.apiService.postData(environment.staffImage,body)
  }
resendPassword(userInternalId,userid,token):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.changeResendPassword+'?UserIntId='+userInternalId+'&UserId='+userid+"&Token="+token);

}
getNursingStation(staffId):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.MapedNursingStation+'?StaffId='+staffId)
}
saveNuringStation(body):Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.MapedNursingStation,body)
}
deleteNursingStation(MapNurseAndNursingUnit):Observable<HttpResponse<any>>{
  return this.apiService.deleteData(environment.MapedNursingStation+'?MapNurseAndNursingUnit='+MapNurseAndNursingUnit)
}
saveChangePin(body):Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.ChangePin,body)
}

getUsersettings(UserId:number){
  return this.apiService.getData(environment.UserPageSettings+'?userId='+UserId)

}

getMenusItem(){
  return this.apiService.getData(environment.MenuItems)
}
  
saveUserSettings(body):Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.SaveUserPageSettings,body)

}
saveLogoutSettings(body:Logout):Observable<HttpResponse<any>> {
  return this.apiService.postData(environment.timeout,body)
}
getLogoutSettingsTime(userId,locationId:number):Observable<HttpResponse<any>> {
  return this.apiService.getData(environment.timeout+"?userId="+userId+"&locationId="+locationId)
}
postAuditLockData(auditLockStatus,body:Auditlog) : Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.auditLock+"?auditLock="+auditLockStatus,body)
}
getAuditLockData(userId:number, locationId:number) : Observable <HttpResponse<any>> {
  return this.apiService.getData(environment.auditLock+"?userId="+userId+"&locationId="+locationId)
}

getUserData():Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.staffUser)
}
getSupervisingDoctor(midPhysicianId:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.supervisingDoctor+'?MidPhyId='+midPhysicianId)
}
saveMedPhysician(body):Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.supervisingMapMidPhy,body)
}
getSupervisingMidPhysician(medPhyId:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.supervisingMidPhysician+"?MidPhyId="+medPhyId)
}
deleteSupervisingPhy(medphyId:number,physicianId:number):Observable<HttpResponse<any>>{
  return this.apiService.deleteData(environment.supervisingMapPhysicianDle+"?MidPhyId="+medphyId+'&PhysicianId='+physicianId)
}
getLocationBasedUsers(locationId:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.locationBasedUser+'?LocationId='+locationId)
 }

 addLocationsInNurseStations(body:AddNursingLocation):Observable<HttpResponse<any>>{
  return this.apiService.postData(environment.nursingLocations,body)
}

getExistLocationInNurseStations(nurseStationId:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.existLocationsInNurseStations+'?NursingStationId='+nurseStationId)
 }

 getRoleNames(): Observable<HttpResponse<RoleName[]>> {
  return this.apiService.getData(environment.roleName);
 }
 getCcdaCodeList(rollName: string): Observable<HttpResponse<CcdaCodeList[]>> {
  return this.apiService.getData(
    environment.CCDACodeList
    + '?RollName=' + rollName
  );
 }

  ccdaCodeList_Consultaion(): Observable<HttpResponse<CcdaCodeList[]>> {
  return this.apiService.getData( environment.ccdaCodeList_Consultaion
  );
 }
 SubConsultData(event): Observable<HttpResponse<CcdaCodeList[]>> {
  return this.apiService.getData( environment.SubConsultData+'?conmnemonic='+event
  );
 }
 ConsultData(): Observable<HttpResponse<CcdaCodeList[]>> {
  return this.apiService.getData( environment.ConsultData);
 }

 getRoleCodeList(code:string):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.roleCodes+'?Code='+code)
 }
 checkNpiData(npi:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.checkNpi+"?NPI="+npi)
 }
saveFontSizeData(fontData: FontData): Observable<HttpResponse<any>> {
  return this.apiService.postData(environment.saveFontSize, fontData);
}
getFontSize(userInternalId:number):Observable<HttpResponse<any>>{
  return this.apiService.getData(environment.saveFontSize+'?UserInternalid='+ userInternalId)
}

  fontSize = signal<number>(12);
// fontSize = signal<number | null>(Number(localStorage.getItem('fontSize')) || 12);
 activeButton = signal<'increase' | 'decrease' | 'reset'>('reset');

  // update font settings
  setFont(size: number, active: 'increase' | 'decrease' | 'reset') {
    this.fontSize.set(size);
    this.activeButton.set(active);
    // localStorage.setItem('fontSize', size.toString());  
  }
}
